<template>
   <div :class="{'oneline': oneLine, 'label-50': label50}" class='input-field'>
      <div v-if="label" class="label">
         {{ label }}: 
      </div>
      <div>
         <select-input
            v-if="type==='select'"
            :size="size"
            v-model="hcValue"
            :options="options"
            :color="errors.length ? 'danger': color"
            :required="required"
            v-bind="extraAttributes"
         />
         <editable-select-input
            v-else-if="type==='editable-select'"
            :size="size"
            v-model="hcValue"
            :options="options"
            :color="errors.length ? 'danger': color"
            :required="required"
            v-bind="extraAttributes"
         />
         <input
            v-else-if="type==='checkbox'"
            type="checkbox"
            v-model="hcValue"
            v-bind="extraAttributes"
            :required="required"
         />
         <el-select
            v-else-if="type==='multi-select'"
            v-model="hcValue"
            multiple
            filterable
            allow-create
            default-first-option
            :placeholder="placeholder">
            <el-option
               v-for="item in options"
               :key="item.value"
               :label="item.title"
               :value="item.value">
            </el-option>
         </el-select>
         <div v-else-if="type==='radio'">
            <div
               class='radio-options'
               v-for="item in options"
               :key="item.value"
               >
               <el-radio
                  v-model="hcValue"
                  :label="item.value"
                  >
                  {{ item.title }}
               </el-radio>
            </div>
         </div>
         <el-date-picker
            v-else-if='["date","day", "month", "week", "year"].includes(type)'
            :type="type"
            :class="{size, 'danger': errors.length, color: errors.length===0}"
            v-model="hcValue"
            :options="options"
            :color="errors.length ? 'danger': color"
            :required="required"
            v-bind="extraAttributes"
         />
         <atom-input
            v-else
            :type="type"
            class="my-1"
            :size="size"
            :color="errors.length ? 'danger' : color"
            :placeholder="placeholder"
            v-model="hcValue"
            :required="required"
            v-bind="extraAttributes"
         />
         <error-list :errors="errors" />
      </div>
   </div>
</template>

<script>
import AtomInput from '../../../atoms/Login/Input';
import SelectInput from '../../../atoms/Home/SelectInput';
import EditableSelectInput from '../../../atoms/Home/EditableSelectInput';
import ErrorList from '../Errors';
import {DatePicker, Radio, Select, Option} from 'element-ui';

// const 
export default {
   name: 'InputField',
   components: {
      AtomInput,
      SelectInput,
      ErrorList,
      EditableSelectInput,
      'el-date-picker': DatePicker,
      'el-select': Select,
      'el-option': Option,
      'el-radio': Radio,
   },
   props: {
      oneLine: {
         type: Boolean,
         default: false,
      },
      label50: {
         type: Boolean,
         default: false,
         validators: () => this.oneLine,// must have oneline for label to be 50%
      },
      type: {
         type: String,
         default: 'text',
         validators: value => this.allAllowedTypes.includes(value),
      },
      label: {
         type: String,
      },
      options: {
         type: Array,
         validators: (value) => this.type==="select"||this.type==="radio" ? value : true, // only required if it's a select input
      },
      placeholder: {
         type: String,
      },
      value: {
         required: true,
         validator: value => (
            value==null ||
            typeof(value) === "string" ||
            typeof(value) === "number" ||
            typeof(value) === "boolean" ||
            value instanceof Date ||
            Array.isArray(value)
         ),
      },
      extraAttributes: {
         type: Object,
         required: false,
      },
      color: {
         type: String,
         default: 'primary',
         validators: value => ['primary', 'success', 'info', 'danger'].includes(value),
      },
      size: {
         type: String,
         default: 'medium',
         validators: value => ['small', 'large', 'medium'].includes(value),
      },
      required: {
         type: Boolean,
         default: false,
      },
      errors: {
         type: Array,
         default: () => [],
      }
   },
   data() {
      const dateTypes = ["date","day", "month", "week", "year"];
      const allAllowedTypes = ["text","number","password","checkbox","select","multi-select","email","radio", "textarea",...dateTypes];
      return {
         dateTypes,
         allAllowedTypes,
      }
   },
   computed: {
      hcValue: {
         get()
         {
            return this.value;
         },
         set(newValue, oldValue)
         {
            if (newValue!==oldValue) this.$emit('input', newValue);
         }
      },
   }
}
</script>

<style lang="scss" scoped>
.input-field {
   margin: 0.65rem 0;
};

.input-field:not(.oneline) {
   .radio-options {
      padding-left: 1em;
   }
}
.oneline {
   display: flex;
   align-items: flex-start;
   .label {
      min-width: max-content;
      margin-top: 0.15em;
      padding-right: 0.4em;
   }
   &.label-50 .label {
      flex: 1;
   }
   .label + div {
      flex: 1;
      *:first-child {
         margin: 0;
      }
      input[type=checkbox] {
         margin-top: 0.66em;
      }
   }
}

.label {
   color: $font-color;
   font-family: $primary-font;
   font-size: 0.9em;
   display: block;
   border-radius: $border-radius;
   padding: 0.2em 0.45em 0em 0.2em;
}

</style>